export default "__VITE_ASSET__DIX3TmRU__"